"use client";

import { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
gsap.registerPlugin(useGSAP);
export default function Minasherointroduction() {
  const container = useRef<HTMLDivElement>(null);
  useGSAP(() => {
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".pd-eyebrow", {
        y: 16
      });
      gsap.set(".pd-heading", {
        y: 24
      });
      gsap.set(".pd-sub", {
        y: 16
      });
      gsap.set(".pd-link", {
        y: 12
      });
      gsap.set(".pd-aurora", {
        scale: 0.9
      });
      const tl = gsap.timeline({
        defaults: {
          ease: "power3.out",
          duration: 0.72
        }
      });
      tl.to(".pd-aurora", {
        opacity: 0.08,
        scale: 1,
        duration: 1.4
      }, 0).to(".pd-eyebrow", {
        opacity: 1,
        y: 0
      }, 0.1).to(".pd-heading", {
        opacity: 1,
        y: 0
      }, 0.2).to(".pd-sub", {
        opacity: 1,
        y: 0
      }, 0.3).to(".pd-link", {
        opacity: 1,
        y: 0
      }, 0.4);
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".pd-eyebrow", ".pd-heading", ".pd-sub", ".pd-link"], {
        opacity: 1,
        y: 0
      });
      gsap.set(".pd-aurora", {
        opacity: 0.08,
        scale: 1
      });
    });
  }, {
    scope: container
  });
  return <section className="bg-background text-foreground overflow-hidden relative">
      <div ref={container} className="mx-auto max-w-[1360px] px-4 sm:px-6 lg:px-8 py-[clamp(140px,18vh,220px)] relative">
        <div aria-hidden="true" className="pd-aurora pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[680px] h-[480px] bg-[radial-gradient(ellipse_at_center,hsl(215_90%_45%),transparent_70%)] blur-3xl" style={{
        opacity: 0
      }} />

        <div className="max-w-3xl mx-auto text-center relative z-10">
          <div className="pd-eyebrow text-xs sm:text-sm font-semibold uppercase tracking-wider text-secondary mb-4" style={{
          opacity: 0
        }}>
            Indústria Mineira
          </div>

          <h1 className="pd-heading font-bold text-[clamp(2.5rem,6vw,5.5rem)] leading-[1.1] tracking-tight text-foreground mb-6" style={{
          opacity: 0
        }}>
            Controlo de Poeiras para Minas
          </h1>

          <p className="pd-sub text-base sm:text-lg md:text-xl text-muted-foreground leading-relaxed max-w-2xl mx-auto" style={{
          opacity: 0
        }}>
            Da limpeza de lama de bauxite ao controlo de poeiras em transportadoras, chutes de transferência, silos ROM, pilhas de armazenamento e vagões ferroviários, as soluções de pulverização da Spraying Systems Co. ajudam as unidades mineiras a suprimir poeiras em suspensão, proteger equipamento e cumprir normas de segurança e ambientais em toda a cadeia de produção.
          </p>

          <div className="pd-link mt-8 flex justify-center" style={{
          opacity: 0
        }}>
            <Button asChild size="lg" className="rounded-lg px-6 py-3 font-medium">
              <Link to="/ContactsPage" className="inline-flex items-center gap-2">
                <span>Consulte-nos</span>
                <ArrowUpRight className="size-4" aria-hidden="true" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}